@if (this.showOverlay) {
<div
  class="overlay disconnect-overlay"
  role="dialog"
  aria-modal="true"
  aria-labelledby="disconnect-overlay-title"
>
  <div class="container">
    @if (this.socketService.disconnectReason === 'thereCanOnlyBeOne') {
    <h3
      id="disconnect-overlay-title"
      i18n="@@dc-overlay-thereCanOnlyBeOne-title"
    >Es wurde ein weiteres Fenster geöffnet!</h3>
    <p
      class="description"
      i18n="@@dc-overlay-thereCanOnlyBeOne-description"
    >
      Du bist jetzt in einem neuen Fenster verbunden. Dieses Fenster wurde deaktiviert. Bitte stelle sicher, dass
      du nur in einem Fenster gleichzeitig aktiv bist, um Konflikte zu vermeiden.
    </p>
    <button
      type="button"
      class="btn btn-sm"
      (click)="this.refresh()"
    >
      <i
        class="ri-restart-line"
        aria-hidden="true"
      ></i>
      <span i18n="@@dc-overlay-thereCanOnlyBeOne-continue">Hier fortfahren</span>
    </button>
    }
    @if (this.socketService.disconnectReason !== 'thereCanOnlyBeOne') {
    <h3
      id="disconnect-overlay-title"
      i18n="@@dc-overlay-default-title"
    >Verbindung verloren</h3>
    <p
      class="description"
      i18n="@@dc-overlay-default-description"
    >
      Möglicherweise bist du offline
    </p>
    <button
      type="button"
      class="btn btn-sm"
      (click)="this.refresh()"
    >
      <i
        class="ri-restart-line"
        aria-hidden="true"
      ></i>
      <span i18n="@@dc-overlay-default-continue">Seite neu laden</span>
    </button>
    <button
      type="button"
      class="btn btn-sm"
      (click)="this.saveChat()"
    >
      <i
        class="ri-chat-download-line"
        aria-hidden="true"
      ></i>
      <span i18n="@@dc-overlay-default-saveChat">Dialog als Text herunterladen</span>
    </button>
    }
  </div>
</div>
}